import { createFileRoute } from '@tanstack/react-router'
import { DetailingQuotePage } from '../components/pages/DetailingQuotePage'
import { publicPageHead } from '../lib/seo'

export const Route = createFileRoute('/detailing_/quote')({
  validateSearch: (search: Record<string, unknown>) => ({
    interests: typeof search.interests === 'string' ? search.interests : undefined,
  }),
  component: DetailingQuotePage,
  head: () => publicPageHead({
    title: 'Request a Tailored Detailing Quote | Autoglow Detailing',
    description:
      'Request a tailored car detailing recommendation from Autoglow in Drysdale. Tell us about the vehicle, condition and the finish you want — no fixed package menu.',
    path: '/detailing/quote',
    ogTitle: 'Tailored Detailing Quote | Autoglow',
    robots: 'noindex,follow',
  }),
})
